{
  "title": "Giải thích cấp",
  "label": "VIP",
  "levelLabel": "VIP {{level}}",
  "levelChangeConditions": "Điều kiện thay đổi cấp",
  "levelChangeHint": "Đạt điều kiện nâng cấp A hoặc B để được nâng cấp. Nếu không đạt điều kiện duy trì cấp A hoặc B, bạn sẽ bị hạ cấp ở kỳ tiếp theo.",
  "compareBenefits": "So sánh quyền lợi theo cấp",
  "vipLevel": "Cấp VIP",
  "sellOrderLevelCondition": "Điều kiện cấp lệnh bán",
  "or": "hoặc",
  "exchangeLevelCondition": "Điều kiện cấp quy đổi ({{token}})",
  "maintainNext": "Duy trì V{{level}} kỳ sau",
  "promote": "Nâng lên V{{level}}",
  "demoteNext": "Hạ xuống V{{level}} kỳ sau",
  "maintain": "Duy trì V{{level}}",
  "maintainLevel": "duy trì cấp",
  "upgrade": "nâng cấp",
  "conditionA": "Điều kiện {{action}} A",
  "conditionB": "Điều kiện {{action}} B",
  "currentPeriodSellOrderCount": "Số lệnh bán kỳ này",
  "currentPeriodSellOrderCountTarget": "Số lệnh bán kỳ này đạt",
  "currentPeriodSellOrderAmount": "Số lượng lệnh bán kỳ này ({{token}})",
  "currentPeriodSellOrderAmountTarget": "Số lượng lệnh bán kỳ này ({{token}}) đạt",
  "currentPeriodExchangeAmount": "Số lượng quy đổi kỳ này ({{token}})",
  "currentPeriodExchangeAmountTarget": "Số lượng quy đổi kỳ này ({{token}}) đạt",
  "countOnly": "Đạt {{count}} lệnh",
  "amountOnly": "Số tiền đạt {{amount}}",
  "countAndAmount": "Đạt {{count}} lệnh\nvà số lượng đạt {{amount}} {{token}}"
}
